module.exports = __webpack_public_path__ + "img/border6.b5430ff6.png";